import linkResolver from '~/lib/link-resolver'

import type { LinkProps } from '~/components/UI/Link'

import { capitalize } from '~/utils/capitalize'
import i18n from '~/utils/i18n'
import { isDefaultLocale } from '~/utils/locales'

import { GENERAL } from './dictionary'

interface UidsProps {
  uid: string
  type: string
  name?: string
}
export interface SerializedBreadcrumbProps {
  rootLink?: LinkProps | LinkProps[]
  items?: UidsProps[]
  locale?: string
}

interface ItemFromUid {
  uid?: string
  name?: string
  type?: string
  locale?: string
}

function formatFromUid({ uid, name, type, locale }: ItemFromUid) {
  return {
    children: name
      ? capitalize(name)
      : uid
        ? // Replace - by space
        capitalize(uid?.split('-')?.join(' '))
        : null,
    href:
      linkResolver(
        {
          uid: uid ?? null,
          type: type ?? null,
        },
        locale,
      ) ?? null,
  }
}

// Default breadcrumb is : [HOME]/[ROOTLINK - FRAGRANCE OR FASHION]/[ITEMS]
export default function serializeBreadcrumb({
  rootLink = null,
  items = [],
  locale,
}: SerializedBreadcrumbProps): LinkProps[] {
  const defaultLocale = isDefaultLocale(locale)

  return [
    //[HOME]
    {
      children: i18n.t(GENERAL.HOME_PAGE),
      href: defaultLocale ? '/' : `/${locale}`,
    },
    //[ROOTLINK - FRAGRANCE OR FASHION]
    ...(rootLink ? (!Array.isArray(rootLink) ? [rootLink] : rootLink) : []),
    //[ITEMS]
    ...(items
      ? items.map((item) =>
        formatFromUid({
          ...item,
          locale,
        }),
      )
      : []),
  ].filter((link) => link.href && link.children)
}
